import { calculatePasswordStrength } from "@msuite/utils/strings";
import clsx from "clsx";
import { motion } from "motion/react";
import type { FC } from "react";

/** Props Interface */
interface PasswordIndicatorProps {
	currentPassword: string | undefined;
}

export const PasswordIndicator: FC<PasswordIndicatorProps> = ({ currentPassword }) => {
	const level = calculatePasswordStrength(currentPassword);
	const percentage = (100 / 4) * level;

	/** Render */
	return (
		<div
			className={clsx(
				"items-stretch w-full h-1",
				"rounded-base overflow-hidden",
				"bg-primaryGray-200 dark:bg-primaryGray-700",
			)}
		>
			<motion.div
				className="bg-linear-to-r/increasing from-red-500 via-amber-500 to-green-500 w-full h-full"
				animate={{
					clipPath: `polygon(0% 0%, ${percentage}% 0%, ${percentage}% 100%, 0% 100%)`,
				}}
			/>
		</div>
	);
};
